import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-steel/30 bg-navy-900 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-41" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-42" data-mp="xu0oy2i5bhfr">
        <h2 id="closing-title" className="text-balance text-center text-3xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-43" data-mp="xs7fygk28l4l">
          Stop Guessing. <span className="text-copper" data-id="element-44" data-mp="17sq25hz3kdpo">Start Understanding Power Distribution &amp; Switchgear.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-45" data-mp="1li1r8toqe1mq">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-copper bg-navy-950 px-4 py-3 text-sm font-semibold text-white" data-id="element-46" data-mp="1hj19zflwj71u" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-copper" aria-hidden="true" data-id="element-47" data-mp="2cajlz1fxr70w" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}